const buildQuery = (params) => '?' +
    Object.entries(params)
        .map(([key, value]) => {
        if (typeof value === 'object') {
            return (value === null || value === void 0 ? void 0 : value.length)
                ? value
                    .map((v) => `${key}=${encodeURIComponent(decodeURIComponent(v))}`)
                    .join('&')
                : null;
        }
        else {
            return `${key}=${encodeURIComponent(decodeURIComponent(value.toString()))}`;
        }
    })
        .filter((e) => !!e)
        .join('&');
export default buildQuery;
//# sourceMappingURL=index.js.map